import { ComponentProps } from 'react';

import { Control, Controller, Path } from 'react-hook-form';

import { TextField, useTheme } from '@mui/material';
import { CustomTextField } from './TextFieldStyled';



interface TextFieldControlledProps<T>
    extends Omit<ComponentProps<typeof TextField>, 'value' | 'onChange'> {
    control: Control<T>;
    name: Path<T>;
    maxValue?: number;
    minValue?: number;
}

const TextFieldControlled = <T,>({
    control,
    name,
    variant = 'filled',
    maxValue,
    minValue,
    InputProps,
    ...props
}: TextFieldControlledProps<T>) => {
    const theme = useTheme();

    return (
        <Controller
            control={control}
            name={name}
            render={({
                field: { value, onChange, onBlur },
                fieldState: { error },
            }) => (
                <CustomTextField
                    variant="outlined"
                    {...props}
                    InputProps={{
                        ...InputProps,
                        onBlur,
                        inputProps: {
                            max: maxValue,
                            min: minValue,
                            sx: {
                                backgroundColor: 'white',
                            },
                        },
                    }}
                    value={value ? value : ''}
                    onChange={onChange}
                    error={!!error?.message}
                    helperText={error?.message}
                />
            )}
        />
    );
};

export default TextFieldControlled;
